import { useCallback, useMemo, useState } from 'react';

/** Selección múltiple para envío carrusel a Telegram (admin). */
export function useAdminCarouselSelection({ enabled = false, max = 10 } = {}) {
  const [selectedIds, setSelectedIds] = useState(() => new Set());

  const toggle = useCallback(id => {
    const key = String(id);
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else {
        if (next.size >= max) return prev;
        next.add(key);
      }
      return next;
    });
  }, [max]);

  const clear = useCallback(() => setSelectedIds(new Set()), []);

  const isSelected = useCallback(id => selectedIds.has(String(id)), [selectedIds]);

  const count = selectedIds.size;
  const ids = useMemo(() => [...selectedIds], [selectedIds]);

  const toggleAll = useCallback(
    rowIds => {
      const list = (rowIds || []).map(String).filter(Boolean);
      if (!list.length) return;
      setSelectedIds(prev => {
        const allOn = list.every(id => prev.has(id));
        if (allOn) {
          const next = new Set(prev);
          list.forEach(id => next.delete(id));
          return next;
        }
        const next = new Set(prev);
        for (const id of list) {
          if (next.size >= max) break;
          next.add(id);
        }
        return next;
      });
    },
    [max],
  );

  return {
    enabled,
    selectedIds,
    ids,
    count,
    max,
    toggle,
    toggleAll,
    clear,
    isSelected,
    atMax: count >= max,
  };
}
